import { UserConnectionActionType } from '@alltrails/shared/types/belay';
import CommunityConnectActionLocation from '@alltrails/analytics/enums/CommunityConnectActionLocation';
import logCommunityConnectActionSelected from '@alltrails/analytics/events/logCommunityConnectActionSelected';
import { IdKey } from '@alltrails/shared/types/lists';
import { getRelationshipAction } from '@alltrails/shared/utils/community/analyticsHelpers';

const onUserActionClick = (
  actionType: UserConnectionActionType,
  userId: IdKey,
  otherUserId: IdKey,
  takeUserAction: (actionType: UserConnectionActionType) => void
) => {
  logCommunityConnectActionSelected({
    relationship_action: getRelationshipAction(actionType),
    carousel_position: -1,
    item_location: CommunityConnectActionLocation.ThirdPartyProfile,
    item_position: 0,
    source_user_id: userId as string,
    target_user_id: otherUserId as string
  });
  takeUserAction(actionType);
};

export default onUserActionClick;
